export enum TravelRecruitingFlags {
    JobsGridSendJobsButton = 'GT_JOB_GRID_SENDJOBS_BUTTON',
    UpdateSendJobsSelectionText = 'GT_UPDATE_SENDJOBS_TEXT',
    FacilityGridTypeNameColumn = 'GT_FACILITY_GRID_TYPE_NAME_COLUMN',
    RecruitingMarginOtColumns = 'gt-recruiting-margin-ot-columns',
    UntagCandidates = 'gt-set-candidates-untagged',
    FixExternalJobDisplayPayRate = 'gt-fix-external-job-display-payrate',
    PreventCandidateReassignment = 'gt-prevent-candidate-reassignment',
    CandidateSearchModal = 'gt-nova-candidate-search-modal',
    BulkValidJobsEndpoint = 'gt-bulk-valid-jobs-endpoint',
    CandidateReleaseReasonModal = 'gt-candidate-release-reason-modal',
    RecruiterLiveListNoteCharacterLimit = 'gt-recruiter-live-list-note-character-limit',
    SubmitJobClearButton = 'gt-submit-job-clear-button',
    AvailableDateRtoDatesPreventTimezoneIssues = 'gt-availabledate-rtodates-prevent-timezone-issues',
    ReportDuplicateProfileLink = 'gt-report-duplicate-profile-link',
    EnableJobDescriptionWorkHistory = 'gt-enable-job-description-work-history',
    FixPerDiemSubmittalDialog = 'gt-fix-perdiem-submittal-dialog',
    StatusChipsDisplay = 'gt-status-chips-display',
    RemoveOldSubmittalDialog = 'gt-remove-old-submittal-dialog',
    PreventDuplicatedSubmittalJobs = 'gt-prevent-duplicated-submittal-jobs',
    EnableNewWorkExperiencePage = 'gt-enable-new-work-experience-page',
    EnableFacilityPlacementV2 = 'gt-enable-facility-placement-v2'
}
